/* storybook-check-ignore */
import React, { useState } from 'react';
import { Box, Button, Text } from '@opendoor/bricks/core';
import { Modal } from '@opendoor/bricks/complex';
import { useObservability } from '../../helpers/observability';
import { Listing } from '../../declarations/exclusives/listing';
import { getFaqItems } from '../../helpers/exclusives/faq';

interface Props {
  listing: Listing;
}

const [agentFaqItem] = getFaqItems(['if-im-working-with-an-agent-how-are-they-compensated']);

const AgentBuyModal: React.FC<Props> = ({ listing }) => {
  const { trackEvent } = useObservability();
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  return (
    <>
      <Modal
        showClose
        analyticsName="cosmos-exclusives-agent-buy-modal"
        isOpen={isModalOpen}
        onRequestClose={() => setIsModalOpen(!isModalOpen)}
        hasPadding={false}
        desktopAndTabletSize="lg"
        className="agent-buy-modal"
        headerProps={{ title: agentFaqItem.title as string }}
      >
        <style
          dangerouslySetInnerHTML={{
            __html: `
              .ei-close {
                stroke: var(--colors-neutrals0) !important;
              }
            `,
          }}
        />
        <Box borderRadius="semiRounded" fontFamily="sans" pb={['5rem', '5rem', '0']}>
          <Box px="2.625rem" pb="5.75rem">
            <br />
            {agentFaqItem.body}
            <br />

            <Button
              aria-label="Contact Opendoor"
              variant="secondary"
              width="100%"
              className="buy-button"
              onClick={() => {
                window.location.assign(
                  `/exclusives/homes/${encodeURIComponent(listing.slug)}/reserve`,
                );
              }}
              analyticsName="cosmos-exclusives-contact-contract"
            >
              I'm interested
            </Button>
          </Box>
        </Box>
      </Modal>
      <Button
        aria-label={null}
        analyticsName="cosmos-exclusives-agent-buy"
        variant="inline-link"
        color="neutrals100"
        textDecoration="none"
        mt="3rem"
        onClick={() => {
          setIsModalOpen(true);
          // TODO: remove categoryOverride
          // observability is initialized with 'cosmos' as the category for all events
          // NOTE: this is also tracked in Journey as `comos-exclusives-agent-buy`
          trackEvent('cta-click', 'buy-with-agent', undefined, {
            categoryOverride: 'exclusive-listings',
          });
        }}
        cursor="pointer"
        fontSize="s1"
      >
        Have an agent?{' '}
        <Text as="span" color="brand50" fontWeight="semibold">
          Buy it for the Off-Market Exclusive Price + agent fees
        </Text>
      </Button>
    </>
  );
};

export default AgentBuyModal;
